/**
 * Network Information API helpers used to pick a sensible default video
 * quality. `navigator.connection` is Chromium-only (no Safari/Firefox
 * support as of writing) — callers should always treat `null` as "unknown"
 * and fall back to a safe default rather than failing.
 */
export function getEffectiveConnectionType() {
  if (typeof navigator === 'undefined') return null;
  const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  return conn?.effectiveType || null;
}

export function isSlowConnection() {
  const type = getEffectiveConnectionType();
  return type === '2g' || type === 'slow-2g';
}

/** Pick a target quality (360/480/720) for local-video "Auto" mode. */
export function autoLocalQualityForConnection() {
  const type = getEffectiveConnectionType();
  if (type === '4g' || type === 'wifi') return 720;
  if (type === '3g') return 480;
  if (type === '2g' || type === 'slow-2g') return 360;
  return 480; // unknown
}
